var map = {
	"./FAVICON_16X16.png": "f926",
	"./FAVICON_32X32.png": "9072",
	"./FAVICON_64X64.png": "1f65",
	"./IMG-20210719-WA0007.jpg": "0677",
	"./IMG-20210719-WA0010.jpg": "ea0f",
	"./VU-LOGO.png": "eca8",
	"./Without_the_word.png": "c525",
	"./begin-chat.svg": "a8d6",
	"./candidate.jpeg": "d64b",
	"./change-password.png": "13da",
	"./check2-circle.png": "aa43",
	"./confirm-vote.png": "9c48",
	"./elections/elections-2025-img-1.webp": "7e44",
	"./elections/elections-2025-img-2.webp": "9c0d",
	"./enter-code.jpg": "78df",
	"./excel.png": "b792",
	"./forgot-password.jpg": "bbb6",
	"./graduate-avatar.jpg": "b34d",
	"./img1.png": "a497",
	"./img2.png": "5f56",
	"./img3.jpg": "d1f6",
	"./img3.png": "92e1",
	"./img4.png": "3015",
	"./img5.png": "2fdf",
	"./light.webp": "392d",
	"./login-img.jpg": "85aa",
	"./no-content.png": "5c55",
	"./no-data.jpg": "bdef",
	"./no-data.png": "78b0",
	"./notice.png": "b852",
	"./notice.svg": "aa5e",
	"./password-updated.jpg": "2b83",
	"./payments/Artboard 1.png": "40fe",
	"./payments/Artboard 2.png": "ef7c",
	"./payments/Artboard 3.png": "e8935",
	"./payments/Artboard 4.png": "f970",
	"./pdf.png": "77ef",
	"./pencil.webp": "66e4",
	"./pesa logo.jpg": "379f",
	"./ppt.png": "6358",
	"./profile-picture.jpg": "0260",
	"./secure.png": "03cd",
	"./students1.png": "c19d",
	"./undraw_voting_nvu7 - Copy.png": "6c8a",
	"./undraw_voting_nvu7.png": "731f",
	"./video-placeholder.webp": "71f1",
	"./vu-logo-with-words.png": "3078",
	"./vu-logo-with-words1.png": "8223",
	"./word.png": "3b84",
	"./words.png": "d20f",
	"./zip.png": "01d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";